import React from "react";

import {
  capitalizeFirstLetter,
  getPriorityLabel,
  getPriorityClass,
  getStatusClass,
} from "../../../controller/global.function.library";

import "./TaskModalForm.scss";

const TaskModalForm = ({
  isFormEditMode,
  setIsFormEditMode,
  isVisible,
  onClose,
  taskData,
  setTaskData,
  handleInputChange,
  handleTaskFormEntry,
  taskErrorMessage,
}) => {
  if (!isVisible) return null;

  const handleEditClick = () => {
    setIsFormEditMode(true);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="side-modal" onClick={(e) => e.stopPropagation()}>
        <button className="cancel-button" onClick={onClose}>
          X
        </button>

        <h3>
          {taskData.id
            ? isFormEditMode
              ? "Update Task Details"
              : "Task Details"
            : "Create New Task"}
        </h3>

        {!isFormEditMode && (
          <div className="modal-view">
            <div className="view-row">
              <label>Task Name</label>
              <div className="view-field">{taskData.name || "-"}</div>
            </div>

            <div className="view-row">
              <label>Description</label>
              <div className="description-view">
                {taskData.description || "-"}
              </div>
            </div>

            <div className="view-row">
              <label>Priority Strength</label>
              <p
                className={`task-form-priority ${getPriorityClass(
                  taskData.priority,
                )}`}
              >
                {getPriorityLabel(taskData.priority)}
              </p>
            </div>

            <div className="view-row">
              <label>Tag Label</label>
              <div className="task-form-label">
                {taskData.tag && taskData.tag.trim() !== ""
                  ? capitalizeFirstLetter(taskData.tag)
                  : "-"}
              </div>
            </div>

            <div className="view-row">
              <label>Status</label>
              <div
                className={`task-form-status-tag ${getStatusClass(
                  taskData.status,
                )}`}
              >
                {taskData.status}
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="edit-button"
                type="button"
                onClick={handleEditClick}
              >
                Edit
              </button>
            </div>
          </div>
        )}

        {isFormEditMode && (
          <form className="modal-form" onSubmit={handleTaskFormEntry}>
            <label className="task-modal-form-label">
              Task Name <span>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={taskData.name}
              onChange={handleInputChange}
              placeholder="Enter task name"
            />

            <label className="task-modal-form-label">
              Description <small> (Optional) </small>
            </label>
            <textarea
              name="description"
              value={taskData.description}
              onChange={handleInputChange}
              placeholder="Enter task description"
            />

            <label>Priority Strength: {taskData.priority}</label>
            <input
              className="slider-input"
              type="range"
              name="priority"
              min="1"
              max="10"
              step="1"
              value={taskData.priority}
              onChange={handleInputChange}
            />

            <div className="tag-line">
              <button
                type="button"
                className={`tag-chip work ${
                  taskData.tag === "Work" ? "active" : ""
                }`}
                onClick={() =>
                  setTaskData((previousData) => ({
                    ...previousData,
                    tag: "Work",
                  }))
                }
              >
                Work
              </button>

              <button
                type="button"
                className={`tag-chip personal ${
                  taskData.tag === "Personal" ? "active" : ""
                }`}
                onClick={() =>
                  setTaskData((previousData) => ({
                    ...previousData,
                    tag: "Personal",
                  }))
                }
              >
                Personal
              </button>

              <button
                type="button"
                className={`tag-chip custom ${
                  taskData.tag !== "Work" && taskData.tag !== "Personal"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setTaskData((previousData) => ({
                    ...previousData,
                    tag: "",
                  }))
                }
              >
                Custom
              </button>

              {taskData.tag !== "Work" && taskData.tag !== "Personal" && (
                <div className="custom-input-wrapper">
                  <input
                    type="text"
                    name="tag"
                    value={taskData.tag}
                    onChange={handleInputChange}
                    placeholder="Enter a custom tag"
                    className="custom-tag-input"
                    autoFocus
                  />
                </div>
              )}
            </div>

            <label>Status</label>
            <select
              name="status"
              value={taskData.status}
              onChange={handleInputChange}
            >
              <option value="Not Started">Not Started</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="On Hold">On Hold</option>
            </select>

            {taskErrorMessage && (
              <p style={{ color: "red" }}>{taskErrorMessage}</p>
            )}

            <div className="modal-actions">
              <button type="submit" className="save-button">
                Save
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default TaskModalForm;
